/**
 * 上传组件的主入口和主控制程序
 * @param opts
 * @constructor
 */
import { reactive } from 'vue';
import tcutils from "./tcutils";
import event from "./tcevent";
import TcFile from "./tcfile";
import Chunk from "./tcchunk";
TcUploader.defaults = {
  singleFile: false,
  chunkSize: 5 * 1024 * 1024, // 切片大小
  maxChunkRetries: 3, // 分片最大重试上传次数
  speedSmoothingFactor: 0.02,
  simultaneousUploads: 3,
};
TcUploader.utils = tcutils;
TcUploader.event = event;
export default function TcUploader(opts) {
  this.opts = tcutils.extend({}, TcUploader.defaults, opts || {});
  this.preventEvent = tcutils.bind(this._preventEvent, this);
  this.fileList = [];
}

tcutils.extend(TcUploader.prototype, event);
tcutils.extend(TcUploader.prototype, {
  _trigger: function (name) {
    var args = tcutils.toArray(arguments);
    var preventDefault = !this.trigger.apply(this, arguments);
    if (name !== 'catchAll') {
      args.unshift('catchAll');
      preventDefault = !this.trigger.apply(this, args) || preventDefault;
    }
    return !preventDefault;
  },

  addFiles: function (files, evt) {
    console.log(files);
    tcutils.each(files, async function (file) {
      // 生成对应的文件对象
      var _file = reactive(new TcFile(this, file, this));
      this.fileList.push(_file);
      if (this._trigger('fileAdded', _file)) {
        this.upload();
      }
    }, this);

  },

  uploadNextFile: function () {
    var pendingStatus = Chunk.STATUS.PENDING;
    var found = false;
    tcutils.each(this.fileList, async function (_file) {
      if (_file.state === pendingStatus) {
        _file.fileChunk(this.opts.chunkSize);
        _file.md5 = await _file.computeMD5();
        if (_file.md5 !== "removed") {
          this._trigger('fileverifyupload', _file);
        }
        found = true;
        return false;
      } else {
        return true;
      }
    }, this);
    return found;
  },

  upload: function () {
    let ret = this._shouldUploadNext();
    if (ret === false) {
      return;
    }
    this._trigger('uploadStart');
    let _allstarted = false;
    for (var num = 1; num <= this.opts.simultaneousUploads - ret; num++) {
      _allstarted = this.uploadNextFile();
      // 如果返回了更多需要下载任务了则停止循环
      if (!_allstarted) {
        break;
      }
    }
  },

  /**
   * should upload next chunk
   * @function
   * @returns {Boolean|Number}
   */
  _shouldUploadNext: function () {
    var num = 0;
    var should = true;
    var simultaneousUploads = this.opts.simultaneousUploads;
    var uploadingStatus = Chunk.STATUS.UPLOADING;
    tcutils.each(this.fileList, function (file) {
      if (file.state === uploadingStatus || file.state === TcFile.STATUS.CHUNKING || file.state === TcFile.STATUS.COMPUTEMD5) {
        num++;
        if (num >= simultaneousUploads) {
          should = false;
          return false;
        }
      }
    });
    // if should is true then return uploading file length
    return should && num;
  },

  /**
   *
   * @param domNodes
   * @param isDirectory 是否选择文件夹上传
   * @param singleFile  是否只能选择单个文件
   * @param attributes  其他属性 如只能上传图片等
   */
  bindUploadBtn: function (domNodes, isDirectory, singleFile, attributes) {
    if (typeof domNodes.length === 'undefined') {
      domNodes = [domNodes];
    }
    tcutils.each(domNodes, function (domNode) {
      var input;
      if (domNode.tagName === 'INPUT' && domNode.type === 'file') {
        input = domNode;
      } else {
        input = document.createElement('input');
        input.setAttribute('type', 'file');
        // display:none - not working in opera 12
        tcutils.extend(input.style, {
          visibility: 'hidden',
          position: 'absolute',
          width: '1px',
          height: '1px'
        });
        domNode.appendChild(input);
        domNode.addEventListener('click', function (e) {
          if (domNode.tagName.toLowerCase() === 'label') {
            return;
          }
          input.click();
        }, false);
      }
      if (!this.opts.singleFile && !singleFile) {
        input.setAttribute('multiple', 'multiple');
      }
      if (isDirectory) {
        input.setAttribute('webkitdirectory', 'webkitdirectory');
      }
      attributes && tcutils.each(attributes, function (value, key) {
        input.setAttribute(key, value);
      });
      // When new files are added, simply append them to the overall list
      var that = this;
      input.addEventListener('change', function (e) {
        that._trigger(e.type, e);
        if (e.target.value) {
          that.addFiles(e.target.files, e);
          e.target.value = '';
        }
      }, false);
    }, this);
  },

  removeFile(_file) {
    for (let i = 0; i < this.fileList.length; i++) {
      const _fileItem = this.fileList[i];
      if (_fileItem.md5 === _file.md5) {
        this.fileList.splice(i, 1);
        break;
      }
    }
  },
  _preventEvent: function (e) {
    tcutils.preventEvent(e);
    this._trigger(e.type, e);
  },

  _assignHelper: function (domNodes, handles, remove) {
    if (typeof domNodes.length === 'undefined') {
      domNodes = [domNodes];
    }
    var evtMethod = remove ? 'removeEventListener' : 'addEventListener';
    tcutils.each(domNodes, function (domNode) {
      tcutils.each(handles, function (handler, name) {
        domNode[evtMethod](name, handler, false);
      }, this);
    }, this);
  },
  /**
   * Assign one or more DOM nodes as a drop target.
   * @function
   * @param {Element|Array.<Element>} domNodes
   */
  bindUploadDrop: function (domNodes) {
    this._onDrop = tcutils.bind(this.onDrop, this);
    this._assignHelper(domNodes, {
      dragover: this.preventEvent,
      dragenter: this.preventEvent,
      dragleave: this.preventEvent,
      drop: this._onDrop
    });
  },

  onDrop: function (evt) {
    this._trigger(evt.type, evt);
    evt.preventDefault();
    this._parseDataTransfer(evt.dataTransfer, evt);
  },
  _parseDataTransfer: function (dataTransfer, evt) {
    if (dataTransfer.items && dataTransfer.items[0] &&
      dataTransfer.items[0].webkitGetAsEntry) {
      this.webkitReadDataTransfer(dataTransfer, evt);
    } else {
      this.addFiles(dataTransfer.files, evt);
    }
  },

  webkitReadDataTransfer: function (dataTransfer, evt) {
    var self = this;
    var queue = dataTransfer.items.length;
    var files = [];
    tcutils.each(dataTransfer.items, function (item) {
      var entry = item.webkitGetAsEntry();
      if (!entry) {
        decrement();
        return;
      }
      if (entry.isFile) {
        // due to a bug in Chrome's File System API impl - #149735
        fileReadSuccess(item.getAsFile(), entry.fullPath);
      } else {
        readDirectory(entry.createReader());
      }
    });
    function readDirectory(reader) {
      reader.readEntries(function (entries) {
        if (entries.length) {
          queue += entries.length;
          tcutils.each(entries, function (entry) {
            if (entry.isFile) {
              var fullPath = entry.fullPath;
              entry.file(function (file) {
                fileReadSuccess(file, fullPath);
              }, readError);
            } else if (entry.isDirectory) {
              readDirectory(entry.createReader());
            }
          });
          readDirectory(reader);
        } else {
          decrement();
        }
      }, readError);
    }
    function fileReadSuccess(file, fullPath) {
      // relative path should not start with "/"
      file.relativePath = fullPath.substring(1);
      files.push(file);
      decrement();
    }
    function readError(fileError) {
      throw fileError;
    }
    function decrement() {
      if (--queue === 0) {
        self.addFiles(files, evt);
      }
    }
  },



  unBindUploadDrop: function (domNodes) {
    this._assignHelper(domNodes, {
      dragover: this.preventEvent,
      dragenter: this.preventEvent,
      dragleave: this.preventEvent,
      drop: this._onDrop
    }, true);
    this._onDrop = null;
  }

});
